import { useState, useEffect } from "react";
import { CaseStageContext } from "../contexts/CaseContexts";
import NewDutAccordion from "../../../NewDutFlow/NewDutAccordion";
import { PatientServices } from "../../../services/PatientServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CaseServices } from "../../../services/CaseServices";

const getCaseStage = (stage) => {
  return stage?.includes("admission")
    ? "admission"
    : stage?.includes("enhancement")
      ? "enhancement"
      : "discharge";
};
const AiReviewTab = ({ selectedCase }) => {
  const [patientDetails, setPatientDetails] = useState(null);
  const [caseDetails, setCaseDetails] = useState(null);
  const [latestStageData, setLatestStageData] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedImg, setSelectedImg] = useState(null);
  const [caseStage, setCaseStage] = useState(
    getCaseStage(
      selectedCase?.submasterstagestatuses?.[0]?.commandCenterStage?.toLowerCase(),
    ),
  );

  const fetchPatientDetails = async () => {
    try {
      const res = await PatientServices?.getPatientDetails(
        selectedCase?.patient?.id,
      );

      setPatientDetails(res?.data?.patient);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const fetchCaseDetails = async () => {
    try {
      const res = await CaseServices.getCaseDetails(selectedCase?.id);
      setCaseDetails(res?.data?.caseDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const fetchLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(
        selectedCase?.caseId || selectedCase?.id,
      );

      console.log("LATEST CASE STAGE RESPONSE", response?.data);

      setLatestStageData(response?.data);
    } catch (error) {
      console.error("LATEST CASE STAGE ERROR", error);
    }
  };
  useEffect(() => {
    if (!selectedCase?.pmjayRegistrationId) return;

    // fetchDutDetails();
    fetchPatientDetails();
    fetchCaseDetails();
  }, [selectedCase]);
  useEffect(() => {
    if (!selectedCase?.id) return;

    fetchLatestCaseStage();
  }, [selectedCase]);
  return (
    <CaseStageContext.Provider
      value={{
        caseStage,
        setCaseStage,
        patientDetails,
        fetchPatientDetails,
        caseDetails,
        fetchCaseDetails,
        setSelectedDocument,
        setSelectedImg,
        fetchLatestCaseStage,
        latestStageData,
      }}
    >
      <NewDutAccordion />
    </CaseStageContext.Provider>
  );
};

export default AiReviewTab;
